import React, { useDeferredValue, useState } from "react";
import { FiArchive, FiCheckCircle, FiChevronDown, FiChevronLeft, FiChevronRight, FiClock, FiEdit3, FiMapPin, FiPhone, FiSearch, FiTrash2, FiUser, FiUserPlus, FiUsers, FiX } from "react-icons/fi";
import banner from "./assets/img/logo_transparent.png";
import defaultPet from "./assets/img/defaultpet.png";
import "./ManagePets.css";

const initialPets = [
    { id: 1, tagId: "4821-7390", name: "Milo", species: "Dog", breed: "Kelpie cross", sex: "Male", age: "2 years", status: "In care", location: "North Melb. kennels", arrival: "24 Aug 2026", image: "https://images.unsplash.com/photo-1552053831-71594a27632d?auto=format&fit=crop&w=240&h=240&q=80", notes: "Friendly and energetic. Settles well after a morning walk." },
    { id: 2, tagId: "6148-2037", name: "Poppy", species: "Cat", breed: "Domestic shorthair", sex: "Female", age: "8 months", status: "With foster", location: "Jamie L.", arrival: "23 Aug 2026", image: "https://images.unsplash.com/photo-1574158622682-e40e69881006?auto=format&fit=crop&w=240&h=240&q=80" },
    { id: 3, tagId: "9350-1184", name: "Frankie", species: "Dog", breed: "Staffy cross", sex: "Female", age: "4 years", status: "In care", location: "Cranbourne kennels", arrival: "22 Aug 2026", image: "https://images.unsplash.com/photo-1583337130417-3346a1be7dee?auto=format&fit=crop&w=240&h=240&q=80", notes: "Prefers a quiet kennel and slow introductions to other dogs." },
    { id: 4, tagId: "2704-6651", name: "Archie", species: "Cat", breed: "Domestic medium hair", sex: "Male", age: "1 year", status: "Ready to adopt", location: "Cat room 2", arrival: "20 Aug 2026", image: "https://images.unsplash.com/photo-1518791841217-8f162f1e1131?auto=format&fit=crop&w=240&h=240&q=80" },
    { id: 5, tagId: "7319-4028", name: "Luna", species: "Dog", breed: "Greyhound", sex: "Female", age: "3 years", status: "With foster", location: "Priya S.", arrival: "18 Aug 2026", image: "https://images.unsplash.com/photo-1530281700549-e82e7bf110d6?auto=format&fit=crop&w=240&h=240&q=80" },
    { id: 6, tagId: "1586-9743", name: "Teddy", species: "Dog", breed: "Maltese cross", sex: "Male", age: "6 years", status: "Ready to adopt", location: "Small dog wing", arrival: "15 Aug 2026", image: "https://images.unsplash.com/photo-1587300003388-59208cc962cb?auto=format&fit=crop&w=240&h=240&q=80" },
    { id: 7, tagId: "8042-3169", name: "Daisy", species: "Dog", breed: "Beagle", sex: "Female", age: "5 years", status: "In care", location: "North Melb. kennels", arrival: "14 Aug 2026", image: "https://images.unsplash.com/photo-1505628346881-b72b27e84530?auto=format&fit=crop&w=240&h=240&q=80" },
    { id: 8, tagId: "3951-7284", name: "Oscar", species: "Cat", breed: "Domestic shorthair", sex: "Male", age: "2 years", status: "With foster", location: "Jamie L.", arrival: "12 Aug 2026", image: "https://images.unsplash.com/photo-1495360010541-f48722b34f7d?auto=format&fit=crop&w=240&h=240&q=80" },
    { id: 9, tagId: "5276-9013", name: "Ruby", species: "Dog", breed: "Labrador cross", sex: "Female", age: "18 months", status: "Ready to adopt", location: "Cranbourne kennels", arrival: "10 Aug 2026", image: "https://images.unsplash.com/photo-1518717758536-85ae29035b6d?auto=format&fit=crop&w=240&h=240&q=80" },
    { id: 10, tagId: "6823-1457", name: "Simba", species: "Cat", breed: "Domestic longhair", sex: "Male", age: "4 years", status: "In care", location: "Cat room 2", arrival: "9 Aug 2026", image: "https://images.unsplash.com/photo-1514888286974-6c03e2ca1dba?auto=format&fit=crop&w=240&h=240&q=80" },
    { id: 11, tagId: "2497-5801", name: "Ziggy", species: "Dog", breed: "Jack Russell cross", sex: "Male", age: "3 years", status: "With foster", location: "Priya S.", arrival: "7 Aug 2026", image: "https://images.unsplash.com/photo-1558788353-f76d92427f16?auto=format&fit=crop&w=240&h=240&q=80" },
    { id: 12, tagId: "7630-4295", name: "Cleo", species: "Cat", breed: "Tortoiseshell", sex: "Female", age: "7 years", status: "Ready to adopt", location: "Cat room 2", arrival: "5 Aug 2026", image: "https://images.unsplash.com/photo-1573865526739-10659fec78a5?auto=format&fit=crop&w=240&h=240&q=80" },
    { id: 13, tagId: "4168-7920", name: "Banjo", species: "Dog", breed: "Cattle dog cross", sex: "Male", age: "2 years", status: "In care", location: "Cranbourne kennels", arrival: "3 Aug 2026", image: "https://images.unsplash.com/photo-1477884213360-7e9d7dcc1e48?auto=format&fit=crop&w=240&h=240&q=80" },
    { id: 14, tagId: "9502-6371", name: "Nala", species: "Cat", breed: "Domestic shorthair", sex: "Female", age: "10 months", status: "With foster", location: "Jamie L.", arrival: "1 Aug 2026", image: "https://images.unsplash.com/photo-1533738363-b7f9aef128ce?auto=format&fit=crop&w=240&h=240&q=80" },
    { id: 15, tagId: "1384-2569", name: "Murphy", species: "Dog", breed: "Border collie cross", sex: "Male", age: "5 years", status: "Ready to adopt", location: "North Melb. kennels", arrival: "29 Jul 2026", image: "https://images.unsplash.com/photo-1551717743-49959800b1f6?auto=format&fit=crop&w=240&h=240&q=80" },
];

const sampleStatusHistory = {
    1: [
        { label: "Accepted into care", detail: "Intake assessment completed", timestamp: "2026-08-24T08:35:00+10:00" },
        { label: "Placed in care location", detail: "North Melbourne Kennels", timestamp: "2026-08-24T10:10:00+10:00" },
    ],
    2: [
        { label: "Accepted into care", detail: "Intake assessment completed", timestamp: "2026-08-23T09:20:00+10:00" },
        { label: "Placed in care location", detail: "Cat Room 2", timestamp: "2026-08-23T11:05:00+10:00" },
        { label: "Placed with foster carer", detail: "Jamie Lewis", timestamp: "2026-08-24T14:30:00+10:00" },
    ],
    3: [
        { label: "Accepted into care", detail: "Intake assessment completed", timestamp: "2026-08-22T08:15:00+10:00" },
        { label: "Placed with foster carer", detail: "Priya Shah", timestamp: "2026-08-22T16:40:00+10:00" },
        { label: "Returned to care from foster", detail: "Returned by Priya Shah", timestamp: "2026-08-23T09:05:00+10:00" },
        { label: "Placed in care location", detail: "Cranbourne Kennels", timestamp: "2026-08-23T10:25:00+10:00" },
    ],
    4: [
        { label: "Accepted into care", detail: "Intake assessment completed", timestamp: "2026-08-20T10:45:00+10:00" },
        { label: "Placed in care location", detail: "Cat Room 2", timestamp: "2026-08-20T12:10:00+10:00" },
        { label: "Marked ready to adopt", detail: "Health and behaviour checks completed", timestamp: "2026-08-23T15:20:00+10:00" },
    ],
    5: [
        { label: "Accepted into care", detail: "Intake assessment completed", timestamp: "2026-08-18T11:10:00+10:00" },
        { label: "Placed in care location", detail: "Cranbourne Kennels", timestamp: "2026-08-18T13:25:00+10:00" },
        { label: "Placed with foster carer", detail: "Priya Shah", timestamp: "2026-08-21T17:15:00+10:00" },
    ],
    6: [
        { label: "Accepted into care", detail: "Intake assessment completed", timestamp: "2026-08-15T09:30:00+10:00" },
        { label: "Placed in care location", detail: "Small Dog Wing", timestamp: "2026-08-15T11:40:00+10:00" },
        { label: "Marked ready to adopt", detail: "Health and behaviour checks completed", timestamp: "2026-08-22T14:10:00+10:00" },
    ],
};

const statusClass = {
    "In care": "in-care",
    "With foster": "with-foster",
    "Ready to adopt": "ready",
    "Adopted": "adopted",
};

const locationDirectory = {
    "North Melb. kennels": { type: "WagTag facility", name: "North Melbourne Kennels", contact: "Morgan Reed", address: "2 Gracie Street, North Melbourne VIC 3051", phone: "(03) 9329 2755" },
    "Cranbourne kennels": { type: "WagTag facility", name: "Cranbourne Kennels", contact: "Alicia Grant", address: "10 Sladen Street, Cranbourne VIC 3977", phone: "(03) 5996 2801" },
    "Cat room 2": { type: "WagTag facility", name: "Cat Room 2", contact: "Alicia Grant", address: "14 Seafarer Road, Brookvale NSW 2100", phone: "(02) 9123 4402" },
    "Small dog wing": { type: "WagTag facility", name: "Small Dog Wing", contact: "Morgan Reed", address: "14 Seafarer Road, Brookvale NSW 2100", phone: "(02) 9123 4401" },
    "Intake": { type: "WagTag facility", name: "Intake and Assessment", contact: "Front desk", address: "14 Seafarer Road, Brookvale NSW 2100", phone: "(02) 9123 4400" },
    "Jamie L.": { type: "Foster home", name: "Jamie Lewis", contact: "Jamie Lewis", address: "8 Banksia Street, Dee Why NSW 2099", phone: "0412 345 810" },
    "Priya S.": { type: "Foster home", name: "Priya Shah", contact: "Priya Shah", address: "21 Ocean View Avenue, Manly NSW 2095", phone: "0438 291 604" },
};

const formatHistoryTimestamp = (timestamp) => new Intl.DateTimeFormat("en-AU", {
    dateStyle: "medium",
    timeStyle: "short",
}).format(new Date(timestamp));

const createSampleStatusHistory = (pet) => {
    const monthNumbers = { Jan: "01", Feb: "02", Mar: "03", Apr: "04", May: "05", Jun: "06", Jul: "07", Aug: "08", Sep: "09", Oct: "10", Nov: "11", Dec: "12" };
    const [day, month, year] = pet.arrival.split(" ");
    const acceptedAt = new Date(`${year}-${monthNumbers[month]}-${day.padStart(2, "0")}T09:15:00+10:00`);
    const placedAt = new Date(acceptedAt.getTime() + 2 * 60 * 60 * 1000);
    const history = [
        { label: "Accepted into care", detail: "Intake assessment completed", timestamp: acceptedAt.toISOString() },
    ];

    if (pet.status === "With foster") {
        history.push({ label: "Placed with foster carer", detail: pet.location, timestamp: placedAt.toISOString() });
    } else {
        history.push({ label: "Placed in care location", detail: pet.location, timestamp: placedAt.toISOString() });
    }

    if (pet.status === "Ready to adopt") {
        history.push({ label: "Marked ready to adopt", detail: "Health and behaviour checks completed", timestamp: new Date(placedAt.getTime() + 3 * 24 * 60 * 60 * 1000).toISOString() });
    }

    return history;
};

const PAGE_SIZE = 5;

function ManagePets() {
    const [pets, setPets] = useState(() => initialPets.map((pet) => ({
        ...pet,
        statusHistory: sampleStatusHistory[pet.id] || createSampleStatusHistory(pet),
    })));
    const [selectedIds, setSelectedIds] = useState([]);
    const [search, setSearch] = useState("");
    const [status, setStatus] = useState("All statuses");
    const [currentPage, setCurrentPage] = useState(1);
    const [dialog, setDialog] = useState(null);
    const [transferTo, setTransferTo] = useState("");
    const [intakeName, setIntakeName] = useState("");
    const [intakeTagId, setIntakeTagId] = useState("");
    const [activeLocation, setActiveLocation] = useState(null);
    const [activeStatusPetId, setActiveStatusPetId] = useState(null);
    const [profileDraft, setProfileDraft] = useState(null);
    const [notice, setNotice] = useState("");
    const deferredSearch = useDeferredValue(search.trim().toLowerCase());

    const filteredPets = pets.filter((pet) => {
        const matchesStatus = status === "All statuses" || pet.status === status;
        const matchesSearch = !deferredSearch || [pet.name, pet.tagId, pet.breed, pet.location]
            .some((value) => value.toLowerCase().includes(deferredSearch));
        return matchesStatus && matchesSearch;
    });
    const totalPages = Math.max(1, Math.ceil(filteredPets.length / PAGE_SIZE));
    const activePage = Math.min(currentPage, totalPages);
    const pageStart = (activePage - 1) * PAGE_SIZE;
    const visiblePets = filteredPets.slice(pageStart, pageStart + PAGE_SIZE);
    const visibleIds = visiblePets.map((pet) => pet.id);
    const allVisibleSelected = visibleIds.length > 0 && visibleIds.every((id) => selectedIds.includes(id));
    const activeStatusPet = pets.find((pet) => pet.id === activeStatusPetId);

    const togglePet = (id) => {
        setSelectedIds((current) => current.includes(id)
            ? current.filter((selectedId) => selectedId !== id)
            : [...current, id]);
    };

    const toggleAllVisible = () => {
        setSelectedIds((current) => allVisibleSelected
            ? current.filter((id) => !visibleIds.includes(id))
            : [...new Set([...current, ...visibleIds])]);
    };

    const closeDialog = () => {
        setDialog(null);
        setTransferTo("");
        setIntakeName("");
        setIntakeTagId("");
        setActiveLocation(null);
        setActiveStatusPetId(null);
        setProfileDraft(null);
    };

    const editProfile = (pet) => {
        setProfileDraft({ ...pet });
        setDialog("profile");
    };

    const updateProfileField = (field, value) => {
        setProfileDraft((current) => ({ ...current, [field]: value }));
    };

    const saveProfile = () => {
        if (!profileDraft?.name.trim()) return;
        const updatedProfile = {
            ...profileDraft,
            name: profileDraft.name.trim(),
            breed: profileDraft.breed.trim() || "Not recorded",
            age: profileDraft.age.trim() || "Unknown",
        };
        setPets((current) => current.map((pet) => pet.id === updatedProfile.id ? updatedProfile : pet));
        setNotice(`${updatedProfile.name}'s profile was updated.`);
        closeDialog();
    };

    const showLocation = (location) => {
        setActiveLocation(location);
        setDialog("location");
    };

    const showStatusHistory = (petId) => {
        setActiveStatusPetId(petId);
        setDialog("status");
    };

    const addIntake = () => {
        const tagId = intakeTagId.replace(/\D/g, "").slice(0, 8);
        if (!intakeName.trim() || tagId.length !== 8) return;
        setPets((current) => [{
            id: Math.max(0, ...current.map((pet) => pet.id)) + 1,
            tagId: `${tagId.slice(0, 4)}-${tagId.slice(4)}`,
            name: intakeName.trim(),
            species: "Details pending",
            breed: "Not recorded",
            sex: "Unknown",
            age: "Unknown",
            status: "In care",
            location: "Intake",
            arrival: new Intl.DateTimeFormat("en-AU", { day: "2-digit", month: "short", year: "numeric" }).format(new Date()),
            image: defaultPet,
            notes: "",
            statusHistory: [
                { label: "Accepted into care", detail: "Intake assessment started", timestamp: new Date().toISOString() },
                { label: "Placed in care location", detail: "Intake and Assessment", timestamp: new Date().toISOString() },
            ],
        }, ...current]);
        setCurrentPage(1);
        setNotice(`${intakeName.trim()} added to the pet register.`);
        closeDialog();
    };

    const confirmTransfer = () => {
        const destination = transferTo.trim();
        if (!destination) return;
        const timestamp = new Date().toISOString();
        setPets((current) => current.map((pet) => selectedIds.includes(pet.id)
            ? {
                ...pet,
                status: "With foster",
                location: destination,
                statusHistory: [
                    ...(pet.statusHistory || []),
                    {
                        label: pet.status === "With foster" ? "Transferred to foster carer" : "Placed with foster carer",
                        detail: destination,
                        timestamp,
                    },
                ],
            }
            : pet));
        setNotice(`${selectedIds.length} ${selectedIds.length === 1 ? "pet" : "pets"} transferred to ${destination}.`);
        setSelectedIds([]);
        closeDialog();
    };

    const confirmDelete = () => {
        const count = selectedIds.length;
        setPets((current) => current.filter((pet) => !selectedIds.includes(pet.id)));
        setNotice(`${count} ${count === 1 ? "pet" : "pets"} removed.`);
        setSelectedIds([]);
        closeDialog();
    };

    return (
        <div className="manage-pets-page">
            <header className="manage-header">
                <div className="manage-header-inner">
                    <img src={banner} alt="WagTag" className="manage-logo" />
                    <div className="partner-mark">
                        <span className="partner-name">The Lost Dogs Home</span>
                        <span className="partner-role">Partner portal</span>
                    </div>
                </div>
            </header>

            <main className="manage-main">
                <section className="manage-title-row">
                    <div>
                        <p className="manage-eyebrow">PET REGISTER</p>
                        <h1>Manage pets</h1>
                        <p className="manage-summary">Track pets in care and coordinate foster placements.</p>
                    </div>
                    <button className="primary-button" type="button" onClick={() => setDialog("intake")}>
                        <FiArchive aria-hidden="true" /> Add intake
                    </button>
                </section>

                <section className="manage-stats" aria-label="Pet status summary">
                    <div><strong>{pets.length}</strong><span>Active pets</span></div>
                    <div><strong>{pets.filter((pet) => pet.status === "In care").length}</strong><span>In care</span></div>
                    <div><strong>{pets.filter((pet) => pet.status === "With foster").length}</strong><span>With foster</span></div>
                    <div><strong>{pets.filter((pet) => pet.status === "Ready to adopt").length}</strong><span>Ready to adopt</span></div>
                </section>

                {notice && (
                    <div className="manage-notice" role="status">
                        <span>{notice}</span>
                        <button type="button" onClick={() => setNotice("")} aria-label="Dismiss notification"><FiX /></button>
                    </div>
                )}

                <section className="pet-register" aria-label="Pets">
                    <div className="register-toolbar">
                        <label className="search-field">
                            <FiSearch aria-hidden="true" />
                            <input value={search} onChange={(event) => { setSearch(event.target.value); setCurrentPage(1); }} placeholder="Search name, WagTag or breed" />
                        </label>
                        <label className="status-filter">
                            <span className="sr-only">Filter by status</span>
                            <select value={status} onChange={(event) => { setStatus(event.target.value); setCurrentPage(1); }}>
                                <option>All statuses</option>
                                <option>In care</option>
                                <option>With foster</option>
                                <option>Ready to adopt</option>
                                <option>Adopted</option>
                            </select>
                            <FiChevronDown aria-hidden="true" />
                        </label>
                    </div>

                    <div className={`bulk-bar ${selectedIds.length ? "is-active" : ""}`}>
                        <span>{selectedIds.length ? `${selectedIds.length} selected` : "Select pets to take a bulk action"}</span>
                        <div className="bulk-actions">
                            <button type="button" disabled={!selectedIds.length} onClick={() => setDialog("transfer")}><FiUserPlus /> Transfer</button>
                            <button className="delete-button" type="button" disabled={!selectedIds.length} onClick={() => setDialog("delete")}><FiTrash2 /> Delete</button>
                        </div>
                    </div>

                    <div className="pet-table-wrap">
                        <table className="pet-table">
                            <thead>
                                <tr>
                                    <th className="checkbox-cell"><input type="checkbox" checked={allVisibleSelected} onChange={toggleAllVisible} aria-label="Select all visible pets" /></th>
                                    <th>Pet</th><th>WagTag</th><th>Current Status</th><th>Current location</th><th>Arrived</th>
                                </tr>
                            </thead>
                            <tbody>
                                {visiblePets.map((pet) => (
                                    <tr key={pet.id} className={selectedIds.includes(pet.id) ? "selected-row" : ""}>
                                        <td className="checkbox-cell"><input type="checkbox" checked={selectedIds.includes(pet.id)} onChange={() => togglePet(pet.id)} aria-label={`Select ${pet.name}`} /></td>
                                        <td data-label="Pet"><div className="pet-identity"><img src={pet.image || defaultPet} alt="" onError={(event) => { event.currentTarget.src = defaultPet; }} /><div><button className="pet-name-link" type="button" onClick={() => editProfile(pet)}>{pet.name}</button><span>{pet.species}</span></div></div></td>
                                        <td data-label="WagTag"><span className="tag-code">{pet.tagId}</span></td>
                                        <td data-label="Status"><button className="status-link" type="button" onClick={() => showStatusHistory(pet.id)}><span className={`status-pill ${statusClass[pet.status]}`}>{pet.status}</span></button></td>
                                        <td data-label="Location"><button className="location-link" type="button" onClick={() => showLocation(pet.location)}>{pet.location}</button></td>
                                        <td data-label="Arrived">{pet.arrival}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                        {!filteredPets.length && <div className="empty-state"><FiSearch /><strong>No pets found</strong><span>Try a different name, WagTag or status.</span></div>}
                    </div>
                    {filteredPets.length > 0 && (
                        <nav className="pagination" aria-label="Pet list pagination">
                            <span>Showing {pageStart + 1}-{Math.min(pageStart + PAGE_SIZE, filteredPets.length)} of {filteredPets.length}</span>
                            <div>
                                <button type="button" onClick={() => setCurrentPage((page) => Math.max(1, page - 1))} disabled={activePage === 1} aria-label="Previous page"><FiChevronLeft /></button>
                                <strong>Page {activePage} of {totalPages}</strong>
                                <button type="button" onClick={() => setCurrentPage((page) => Math.min(totalPages, page + 1))} disabled={activePage === totalPages} aria-label="Next page"><FiChevronRight /></button>
                            </div>
                        </nav>
                    )}
                </section>
            </main>

            {dialog && (
                <div className="dialog-backdrop" role="presentation" onMouseDown={(event) => event.target === event.currentTarget && closeDialog()}>
                    <div className="manage-dialog" role="dialog" aria-modal="true" aria-labelledby="dialog-title">
                        <button className="dialog-close" type="button" onClick={closeDialog} aria-label="Close"><FiX /></button>
                        {dialog === "status" ? (
                            <>
                                <FiClock className="dialog-icon" aria-hidden="true" />
                                <p className="dialog-kicker">STATUS HISTORY</p>
                                <h2 id="dialog-title">{activeStatusPet.name}</h2>
                                <div className="current-status-summary">
                                    <span>Current status</span>
                                    <span className={`status-pill ${statusClass[activeStatusPet.status]}`}>{activeStatusPet.status}</span>
                                </div>
                                <ol className="status-timeline">
                                    {(activeStatusPet.statusHistory || []).map((event, index) => (
                                        <li key={`${event.timestamp}-${index}`}>
                                            <span className="timeline-marker"><FiCheckCircle aria-hidden="true" /></span>
                                            <div>
                                                <strong>{event.label}</strong>
                                                <span>{event.detail}</span>
                                                <time dateTime={event.timestamp}>{formatHistoryTimestamp(event.timestamp)}</time>
                                            </div>
                                        </li>
                                    ))}
                                </ol>
                                <div className={`adoption-state ${activeStatusPet.status === "Adopted" ? "is-complete" : ""}`}>
                                    {activeStatusPet.status === "Adopted" ? <FiCheckCircle aria-hidden="true" /> : <FiClock aria-hidden="true" />}
                                    <div>
                                        <strong>{activeStatusPet.status === "Adopted" ? "Adopted" : "Not yet adopted"}</strong>
                                        <span>{activeStatusPet.status === "Adopted" ? "Adoption is recorded as the final lifecycle event." : "Adoption will appear here as the final lifecycle event."}</span>
                                    </div>
                                </div>
                                <div className="dialog-actions"><button className="primary-button" type="button" onClick={closeDialog}>Close</button></div>
                            </>
                        ) : dialog === "profile" ? (
                            <>
                                <div className="profile-dialog-header">
                                    <img src={profileDraft.image || defaultPet} alt={`${profileDraft.name} profile`} onError={(event) => { event.currentTarget.src = defaultPet; }} />
                                    <div><p className="dialog-kicker">PET PROFILE</p><h2 id="dialog-title">Edit {profileDraft.name}</h2><span className="profile-tag">WagTag {profileDraft.tagId}</span></div>
                                </div>
                                <div className="profile-fields">
                                    <label className="dialog-field">Pet name<input autoFocus value={profileDraft.name} onChange={(event) => updateProfileField("name", event.target.value)} /></label>
                                    <label className="dialog-field">Species<select value={profileDraft.species} onChange={(event) => updateProfileField("species", event.target.value)}><option>Dog</option><option>Cat</option><option>Other</option></select></label>
                                    <label className="dialog-field">Breed<input value={profileDraft.breed} onChange={(event) => updateProfileField("breed", event.target.value)} /></label>
                                    <label className="dialog-field">Sex<select value={profileDraft.sex} onChange={(event) => updateProfileField("sex", event.target.value)}><option>Female</option><option>Male</option><option>Unknown</option></select></label>
                                    <label className="dialog-field">Age<input value={profileDraft.age} onChange={(event) => updateProfileField("age", event.target.value)} placeholder="e.g. 2 years" /></label>
                                    <label className="dialog-field profile-photo-field">Photo URL<input type="url" value={profileDraft.image || ""} onChange={(event) => updateProfileField("image", event.target.value)} placeholder="https://" /></label>
                                    <label className="dialog-field profile-notes-field">Notes<textarea rows="5" value={profileDraft.notes || ""} onChange={(event) => updateProfileField("notes", event.target.value)} placeholder="Add care instructions, temperament, medical details or other notes" /></label>
                                </div>
                                <div className="dialog-actions"><button type="button" onClick={closeDialog}>Cancel</button><button className="primary-button" type="button" disabled={!profileDraft.name.trim()} onClick={saveProfile}><FiEdit3 /> Save profile</button></div>
                            </>
                        ) : dialog === "location" ? (
                            <>
                                <FiMapPin className="dialog-icon" aria-hidden="true" />
                                <p className="dialog-kicker">{locationDirectory[activeLocation]?.type || "Foster home"}</p>
                                <h2 id="dialog-title">{locationDirectory[activeLocation]?.name || activeLocation}</h2>
                                <dl className="location-details">
                                    <div><dt><FiUser aria-hidden="true" /> Contact</dt><dd>{locationDirectory[activeLocation]?.contact || activeLocation}</dd></div>
                                    <div><dt><FiMapPin aria-hidden="true" /> Address</dt><dd>{locationDirectory[activeLocation]?.address || "Address not recorded"}</dd></div>
                                    <div><dt><FiPhone aria-hidden="true" /> Phone</dt><dd>{locationDirectory[activeLocation]?.phone || "Phone not recorded"}</dd></div>
                                    <div><dt><FiUsers aria-hidden="true" /> Animals currently here</dt><dd>{pets.filter((pet) => pet.location === activeLocation).length}</dd></div>
                                </dl>
                                <div className="dialog-actions"><button className="primary-button" type="button" onClick={closeDialog}>Close</button></div>
                            </>
                        ) : dialog === "intake" ? (
                            <>
                                <FiArchive className="dialog-icon" aria-hidden="true" />
                                <h2 id="dialog-title">Add pet intake</h2>
                                <p>Assign the pet's WagTag as they enter the facility. Profile details can be completed later.</p>
                                <div className="dialog-fields">
                                    <label className="dialog-field">Pet name<input autoFocus value={intakeName} onChange={(event) => setIntakeName(event.target.value)} placeholder="Pet name" /></label>
                                    <label className="dialog-field">WagTag ID<input inputMode="numeric" value={intakeTagId} onChange={(event) => setIntakeTagId(event.target.value.replace(/\D/g, "").slice(0, 8))} placeholder="8 digit Tag ID" /></label>
                                </div>
                                <div className="dialog-actions"><button type="button" onClick={closeDialog}>Cancel</button><button className="primary-button" type="button" disabled={!intakeName.trim() || intakeTagId.length !== 8} onClick={addIntake}>Add pet</button></div>
                            </>
                        ) : dialog === "transfer" ? (
                            <>
                                <FiUserPlus className="dialog-icon" aria-hidden="true" />
                                <h2 id="dialog-title">Transfer {selectedIds.length} {selectedIds.length === 1 ? "pet" : "pets"}</h2>
                                <p>Assign the selected pets to a foster carer or another facility.</p>
                                <label className="dialog-field">Transfer to<input autoFocus value={transferTo} onChange={(event) => setTransferTo(event.target.value)} placeholder="Foster or facility name" /></label>
                                <div className="dialog-actions"><button type="button" onClick={closeDialog}>Cancel</button><button className="primary-button" type="button" disabled={!transferTo.trim()} onClick={confirmTransfer}>Confirm transfer</button></div>
                            </>
                        ) : (
                            <>
                                <FiTrash2 className="dialog-icon danger" aria-hidden="true" />
                                <h2 id="dialog-title">Delete {selectedIds.length} {selectedIds.length === 1 ? "pet" : "pets"}?</h2>
                                <p>This removes the selected records from this register. This action cannot be undone.</p>
                                <div className="dialog-actions"><button type="button" onClick={closeDialog}>Cancel</button><button className="danger-button" type="button" onClick={confirmDelete}>Delete pets</button></div>
                            </>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
}

export default ManagePets;